
/* latin-ext */
@font-face {
  font-family: 'Anonymous Pro Fallback';
  font-style: normal;
  font-weight: 700;
  src:
    url('assets/fonts/anonymous-pro-bold.woff2') format('ttf'),
    url('assets/fonts/AnonymousPro-Bold.ttf') format('woff2'),
    url('/assets/fonts/anonymous-pro-bold.woff2') format('woff2'),
    url('./assets/fonts/anonymous-pro-bold.woff2') format('woff2'),
    local('Anonymous Pro Bold'),
    local('AnonymousPro-Bold');
}


:root {
  --iframe-width: 100%;
  --iframe-height: 100%;
}

* { padding: 0; margin: 0; }
html, body, #fullheight {
    min-height: 100% !important;
    height: 100%;
}